// Views define different places where insights components can be rendered in the component tree, and ViewType
// is the "type" of location where the component is rendered. For example, "MAIN_ANALYTICS_DASHBOARD" means
// the component is rendered in the main Insights tool, and "EMBEDDED_ANALYTICS_DASHBOARD" means it's rendered
// embedded into an item such as an entity.
export enum ViewType {
  EMBEDDED_ANALYTICS_DASHBOARD = 'EMBEDDED_ANALYTICS_DASHBOARD',
  MAIN_ANALYTICS_DASHBOARD = 'MAIN_ANALYTICS_DASHBOARD',
}

// ViewContext further defines the view by adding needed properties to the ViewTypes that are used to define
// the full context of the component being rendered. Commonly, the ViewContext will be used to generate a
// viewStateId to use as a key to access the global state used for a component in a given context.
export type ViewContext =
  | {
      viewType: ViewType.MAIN_ANALYTICS_DASHBOARD;
    }
  | {
      viewType: ViewType.EMBEDDED_ANALYTICS_DASHBOARD;
      embeddingItemId: string;
    };
